/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import { Button } from '@material-ui/core';
import React from 'react';
import { saveAs } from 'file-saver';
import examType1Services from '../../redux/services/examType1Services';
import { createXlsx, exportXlsx } from '../../helpers/utils';
import questionServices from '../../redux/services/questionServices';

const zip = require('jszip')();

const DownloadQuizCorrection = ({ examData }) => {
  const formatType = (type) => {
    let formatedType = '';
    switch (type) {
      case 'mcq':
        formatedType = 'Question à choix multiples';
        return formatedType;
      case 'tof':
        formatedType = 'Vrai ou faux';
        return formatedType;
      case 'fillblank':
        formatedType = 'Remplir les blancs';
        return formatedType;
      case 'd&d':
        formatedType = 'Drag and drop';
        return formatedType;
      default:
        // eslint-disable-next-line no-unused-expressions
        null;
    }
    return formatedType;
  };

  const findTestId = () => {
    let testId;
    for (let i = 0; i < examData.length; i += 1) {
      if (examData[i].note > 0) {
        testId = examData[i].testId;
        break;
      }
    }

    return testId;
  };

  const handleDownload = async () => {
    let test;
    const testId = findTestId();
    try {
      const res = await examType1Services.getTestById(testId);
      const resQp = await questionServices.getQuestionPoolWithQuestions(res.pool);
      test = resQp;

      if (test) {
        let KNTotal = 0;
        let RCTotal = 0;
        let total = 0;
        const finalResults = [];
        test.questions?.forEach((question) => {
          total += question.coefficient;
          if (question.category === 'KN') {
            KNTotal += question.coefficient;
          } else {
            RCTotal += question.coefficient;
          }
          const testObj = {
            question: question?.name || '',
            type: formatType(question?.type) || '',
            catégorie: question?.category || '',
            points: question.coefficient,
          };

          if (question.answers && question.answers.length > 0) {
            question.answers.forEach((answer, index) => {
              if (answer && answer?.text) {
                let name = 'réponse ';
                name += index + 1;
                if (answer.isRight) {
                  answer.text += ' (bonne réponse)';
                }
                testObj[name] = answer.text;
              }
            });
          }
          finalResults.push(testObj);
        });
        finalResults.push({ question: `Total vocabulaire/connaissances: ${KNTotal}` }, { question: `Total compréhension écrite: ${RCTotal}` }, { question: `Total: ${total}` });
        exportXlsx(finalResults, 'Correction_quiz');
      }
    } catch (e) {
      // console.log(e);
    }
  };
  return (
    <Button disableElevation variant="contained" color="primary" size="small" style={{ marginLeft: '8px', marginRight: '15px' }} onClick={handleDownload}>Download correction</Button>
  );
};

export default DownloadQuizCorrection;
